var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca href=\"\u002Fcommunaute\u002Fuser\u002F{{user.userslug}}\" target=\"_self\"\u003E\u003Cspan class=\"profile\" ng-if=\"!user.picture\" ng-style=\"{'background-color': user['icon:bgColor']}\"\u003E{{user[\"icon:text\"]}}\u003C\u002Fspan\u003E\u003Cspan class=\"profile\" ng-if=\"user.picture\" ng-style=\"{'background-image': 'url({{ user['picture'] }})'}\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/directives/avatar/view.jade
// module id = 711
// module chunks = 1